import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ButtonArrowed from '../widgets/Buttons/ButtonArrowed';

import './news-post-title.scss';

const content = {
  '/we/news/': 'Новости',
  '/analyze/actually/': 'Публикации'
};

class NewsPostTitle extends PureComponent {
  render() {
    const className = cn('news-post-title', {
      'has-image': !!this.props.titleImage
    });

    const style = {};
    if (this.props.titleImage) {
      style.backgroundImage = `url(${this.props.titleImage})`;
    }

    return (
      <div className={className} style={style}>
        <div className="container">
          <div className="static-content">
            <ButtonArrowed
              className="news-post-back-link"
              direction="left"
              link={this.props.pathname}
            >
              {content[this.props.pathname]} <i>вернуться</i>
            </ButtonArrowed>

            <h1 dangerouslySetInnerHTML={{ __html: this.props.title }}/>

            <div className="news-post-title-date">
              {this.props.dateDisplay}
            </div>
          </div>
        </div>

        <div className="news-post-title-overlay" />
      </div>
    );
  }
}

NewsPostTitle.propTypes = {
  title: PropTypes.string.isRequired,
  titleImage: PropTypes.string,
  dateDisplay: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired
};

export default NewsPostTitle;



// WEBPACK FOOTER //
// ./src/components/NewsPost/NewsPostTitle.js